import { render, staticRenderFns } from "./comWageGzList.vue?vue&type=template&id=ee1c7ab6&scoped=true&"
import script from "./comWageGzList.vue?vue&type=script&lang=js&"
export * from "./comWageGzList.vue?vue&type=script&lang=js&"
import style0 from "./comWageGzList.vue?vue&type=style&index=0&id=ee1c7ab6&scoped=true&lang=css&"
import style1 from "./comWageGzList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1c7ab6",
  null
  
)

export default component.exports